<template>
    <v-container fluid class="py-0 grey darken-4">
        <v-layout row wrap justify-start>  
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex xs3>
                        <v-layout column>
                            <v-flex>
                                <v-card class="grey darken-4 px-4" flat dark fill-height>
                                    <v-card-title>
                                        Liste 
                                    </v-card-title>
                                    <v-card-text class="pt-0">
                                        <v-radio-group v-model="list" row :mandatory="false">
                                            <v-radio
                                                v-for="list in lists"
                                                :key="list.name"
                                                :label="list.name"
                                                :value="list"                                         
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-card-text>                            
                                </v-card>
                            </v-flex>
                        </v-layout>                
                    </v-flex>
                    <v-flex xs3>
                        <v-layout column>
                            <v-flex>
                                <v-card class="grey darken-4" dark flat fill-height>
                                    <v-card-title>
                                        Suche
                                    </v-card-title>
                                    <v-text-field
                                        class="mt-3 pb-5"
                                        flat
                                        name="search"
                                        label="search"
                                        id="search"
                                        v-model="word"
                                        solo-inverted
                                        clearable
                                        prepend-inner-icon="search"
                                    >                    
                                    </v-text-field> 
                                    <!-- <code>{{ dataobject }}</code> -->
                                </v-card>
                            </v-flex>                    
                        </v-layout>                                
                    </v-flex>
                    <v-flex xs4>                
                        <v-layout column>
                            <v-flex>
                                <v-card class="grey darken-4 px-4" dark flat fill-height>
                                    <v-card-title>                                        
                                        Tags
                                    </v-card-title>
                                    <v-card-text class="pt-0">

                                        <tagselect
                                            :attributes="tagdata.attributes"
                                            vuexnamespace="search"
                                            v-model="searchtags"
                                            >

                                        </tagselect>

                                    </v-card-text>                            
                                </v-card>
                            </v-flex>
                        </v-layout>     
                    </v-flex>
                    <v-flex xs2>
                        <v-btn small 
                               flat 
                               light 
                               class="white"
                               v-on:click.stop="searchCanceled"
                        >
                            <span><v-icon small>close</v-icon> Abbrechen</span>

                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-card color="#fff" light>                        
                   <v-card-text>
                       <v-container fluid fill-height grid-list-xl>
                           <v-layout row wrap fill-height>
                               <!-- <v-flex xs12 v-for="item in filteredList" :key="item.id">                                   
                                   <a v-on:click="select(item)"> 
                                       <span> {{ item.name }}</span>  
                                       <span v-if="item.tags">
                                           <v-chip small v-for="tag in item.tags">
                                               {{ tag.name }}
                                           </v-chip>
                                       </span> 
                                   </a>                                                       
                               </v-flex> -->
                               <v-flex xs12>
                                   <v-list>
                                       <v-list-tile 
                                           v-for="item in filteredList" 
                                           :key="item.id"
                                           v-on:click="select(item)"
                                           >
                                            <v-list-tile-content>
                                                <v-list-tile-title>
                                                    {{ item.name }}
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title v-if="item.tags">
                                                    <v-chip small v-for="tag in item.tags">
                                                        {{ tag.name }}
                                                    </v-chip>
                                                </v-list-tile-sub-title>
                                           </v-list-tile-content>
                                       </v-list-tile>
                                   </v-list>
                               </v-flex>
                           </v-layout>
                       </v-container>            
                   </v-card-text>                
               </v-card>
            </v-flex>
        </v-layout>        
    </v-container>                                                 
</template>
<script>

import tagselect from "../forms/TagSelect.vue"
export default {   
    props:[
        'lists',
        'listitems'
    ],
    components:{
        tagselect:tagselect
    },    
    data() {
        return {    
            title:'Ergebnis',
            word:'',
            list:this.lists[0], 
            searchtags:[],
            tagdata:{
                id:1,
                name:'formselect',
                attributes: {
                    placeholder:"Tags",
                    size:"xs10",
                    invertedsize:"xs1",
                    displaytitle:"name",
                    displaysubtitle:"",
                    multiple:true,
                    icon:"search",
                    variable: 'tags',
                    setter: 'search/SEARCH_SET_TAGS',
                    items:'tags/tags',
                    withdialog:false,
                }                                    
            }
        }
    },
    methods: {
        searchCanceled() {
            this.word='' 
            this.searchtags=[]
            this.$emit('searchCanceled')
            
        },
        select(item) {            
            this.$emit('resultChange',item)            
        }
    },
    
    computed: {                 
       filteredList: function () {                           
            if(this.list == null ) {
                return this.items
            }           
            let mixinField = this.list.variable 
            let mixinList = this.items
            let c = this.list.constraint
            
            if(c.field != "") {                
                mixinList=this.items.filter((e) => {return e[c.field] == c.value})
            }
            if(Array.isArray(this.searchtags) && this.searchtags.length) {
                
                mixinList=mixinList.filter((item)=>{
                    return item.tags.some((tag)=>{
                        return this.searchtags.includes(tag.id)
                    })
                })
            }
            if(this.word != "" && this.word != null)                           
            {                       
                return mixinList.filter((item) => {
                    let field=item[mixinField]                        
                    return field.toString().toLowerCase().match(this.word.toString().toLowerCase());
                }) 
            }
            return mixinList
        },
        tags() {return this.$store.getters['tags/tags']},        
        items(){ return this.$store.getters[this.listitems]},
        //tagdata(){return this.$store.getters['search/tagdata']},        
                
    },
    
    
}
</script>
